import React from "react";
import "./Projects.css";
import demus from "./assets/demus.png";
import codelingo from "./assets/codelingo.jpg";
import hackmidterms from "./assets/hackmidterms.jpg";
import bettr from "./assets/bettr.jpg";

const projectsData = [
  {
    image: demus,
    title: "Decentralized Music App",
    description:
      "A theft proof music app where artists can upload their music and get paid directly by their fans.",
    techStack: ["React", "Polygon Amoy", "Express", "SHA-256"],
    link: "https://github.com/shivanshshrivas/DeMus",
  },
  {
    image: codelingo,
    title: "CodeLingo",
    description:
      "Turn your code into easily understandable visual diagrams for better understanding and debugging.",
    techStack: ["Python", "Flask", "Next.js", "PostgreSQL", "Firebase"],
    link: "https://github.com/an-siuu-man/code-lingo",
  },
  {
    image: bettr,
    title: "Bettr Social Media",
    description:
      "Share your kind memories of the day and get rewarded with Bettr tokens.",
    techStack: ["MongoDB", "Express", "Node.js", "React Native"],
    link: "https://github.com/shivanshshrivas/BEttr",
  },
  {
    image: hackmidterms,
    title: "HackMidterms",
    description:
      "Create flashcards and save them using AI as you watch your favorite online courses.",
    techStack: ["Next.js", "Pinata IPFS", "Firebase", "Whisper (OpenAI)"],
    link: "https://github.com/an-siuu-man/hackmidterms",
  },
];

function ProjectCard({ project }) {
  return (
    <div className="project">
      <div className="project-cover">
        <img
          src={project.image}
          alt={project.title}
          className="project-image"
        />
      </div>
      <div className="tech-stack">
        {project.techStack.map((tech, index) => (
          <span key={index}>{tech}</span>
        ))}
      </div>
      <h1 className="project-title">{project.title}</h1>
      <p className="project-description">{project.description}</p>
      <a
        href={project.link}
        className="project-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        View on Github
      </a>
    </div>
  );
}

function Projects() {
  return (
    <div className="projects-section">
      <div className="projects-container">
        <h1 className="projects-heading">Projects</h1>
        <p className="projects-description">
          Here are some of my selected projects. Check them out and let me know
          how did you like them :)
        </p>
        <div className="projects">
          <div className="col1">
            <ProjectCard project={projectsData[0]} />
            <ProjectCard project={projectsData[2]} />
          </div>
          <div className="col2">
            <ProjectCard project={projectsData[1]} />
            <ProjectCard project={projectsData[3]} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
